/**
 * Fade-and-rise reveal for elements marked with `data-savor-reveal`.
 *
 * Elements start hidden only once this module confirms it can observe them, so a
 * failed or blocked script leaves the page fully readable rather than blank.
 */
const REVEAL_ATTRIBUTE = 'data-savor-reveal';
const READY_CLASS = 'savor-reveal-ready';
const VISIBLE_CLASS = 'savor-reveal-visible';

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

/** @type {IntersectionObserver | null} */
let observer = null;

/** @param {Element} element */
function reveal(element) {
  element.classList.add(VISIBLE_CLASS);
}

function getObserver() {
  if (observer) return observer;

  observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        reveal(entry.target);
        observer?.unobserve(entry.target);
      }
    },
    // Fire a little before the element reaches the fold so the motion reads as
    // the section arriving, not as it correcting itself after the fact.
    { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
  );

  return observer;
}

/** @param {ParentNode} [root] */
function observeAll(root = document) {
  const elements = root.querySelectorAll(`[${REVEAL_ATTRIBUTE}]:not(.${READY_CLASS})`);

  for (const element of elements) {
    element.classList.add(READY_CLASS);

    if (reduceMotion.matches) {
      reveal(element);
      continue;
    }

    getObserver().observe(element);
  }
}

observeAll();

// Sections re-render in the theme editor and through the section rendering API.
new MutationObserver(() => observeAll()).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
